var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoltRed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.88774 17.5C8.59607 17.5 8.37107 17.2417 8.41274 16.95L9.16274 11.6667H6.24607C5.51274 11.6667 5.97107 11.0417 5.98774 11.0167C7.03774 9.15833 8.61274 6.40833 10.6961 2.74167C10.7794 2.59167 10.9461 2.5 11.1127 2.5C11.4044 2.5 11.6294 2.75833 11.5877 3.05L10.8377 8.33333H13.7627C14.0961 8.33333 14.2794 8.49167 14.0961 8.88333C11.3544 13.6667 9.76274 16.4583 9.3044 17.2583C9.22107 17.4083 9.06274 17.5 8.88774 17.5Z",
    fill: "#E01E00"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoltRed);
export default __webpack_public_path__ + "static/media/boltRed.4c74b3f7ae9f6afdfd2d2efc87d0a64f.svg";
export { ForwardRef as ReactComponent };